import useApiQuery from 'shared/hooks/use-api-query';
import {NeighborhoodProps} from '../types';
import neighborhoodsKeys from '../util/neighborhoods-keys';
import {SelectDataProps} from 'shared/types/select-data';

const useNeighborhoodsSelect = (cityId?: string) => {
  const {data = [], ...rest} = useApiQuery({
    url: `/neighborhoods/cities/${cityId}`,
    queryKey: neighborhoodsKeys.cities(cityId!),
    enabled: !!cityId,
  });

  return {
    ...rest,
    data: data?.map((neighborhood: NeighborhoodProps) => ({
      label: neighborhood.name,
      value: neighborhood.id,
    })) as SelectDataProps[],
  };
};

export default useNeighborhoodsSelect;
